import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";
import { TerminalAttachment } from "./terminalAttachment";

export const terminalAttachmentsApi = createApi({
    reducerPath: "terminalAttachmentsApi",
    baseQuery,
    tagTypes: ["TerminalAttachment"],
    endpoints: (builder) => ({

        getTerminalAttachments: builder.query<TerminalAttachment[], number>({
            query: (terminalId) => `terminals/${terminalId}/attachments`,
            transformResponse: (response: { data: TerminalAttachment[] }) => response.data,
            providesTags: ["TerminalAttachment"],
        }),

        createTerminalAttachment: builder.mutation<TerminalAttachment, { terminalId: number; file: File }>({
            query: ({ terminalId, file }) => {
                const formData = new FormData();
                formData.append("file", file);
                return {
                    url: `terminals/${terminalId}/attachments`,
                    method: "post",
                    body: formData,
                };
            },
            invalidatesTags: ["TerminalAttachment"],
        }),

        deleteTerminalAttachment: builder.mutation<void, { terminalId: number; attachmentId: number }>({
            query: ({ terminalId, attachmentId }) => ({
                url: `terminals/${terminalId}/attachments/${attachmentId}`,
                method: "delete",
            }),
            invalidatesTags: ["TerminalAttachment"],
        }),

    }),
});

export const {
    useGetTerminalAttachmentsQuery,
    useCreateTerminalAttachmentMutation,
    useDeleteTerminalAttachmentMutation,
} = terminalAttachmentsApi;
